/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {Fragment} from 'react';
import {List, makeStyles} from '@material-ui/core';
import classnames from 'classnames';
import {dlsColor} from '../../../theme/theme';
import {SavedMapViewType} from '../../../types/types';
import MapViewListItem from './SavedMapViewsChooserListItem';

interface SavedMapViewsChooserListType {
  savedMapViews?: SavedMapViewType[]
  onEdit?: Function
  onDelete?: Function
  onSetMapView?: Function
  onSetDefaultMapView?: Function
  isTracking?: boolean
}

const useStyles = makeStyles(theme => ({
  itemPointerEvents : {
    pointerEvents : 'auto'
  },
  root : {
    width           : '100%',
    backgroundColor : dlsColor('white'),
    justifyContent  : 'space-between',
    cursor          : 'pointer',
    '&:hover'       : {
      backgroundColor : dlsColor('paleBlue')
    },
    '&.MuiList-padding' : {
      paddingBottom : '0px'
    }
  },
  mapViewList : {
    overflow                       : 'auto',
    maxHeight                      : 345,
    overflowX                      : 'hidden',
    boxShadow                      : '6px 6px 10px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('sm')] : {
      maxHeight : 'calc(100vh - 250px)'
    }
  }
}));

const SavedMapViewsChooserList = ({
  isTracking,
  savedMapViews,
  onEdit,
  onDelete,
  onSetMapView,
  onSetDefaultMapView
}: SavedMapViewsChooserListType) => {
  const classes = useStyles();
  return (
    <List className={classes.mapViewList}>
      {savedMapViews?.map(mapView => (
        <Fragment key={mapView.id}>
          <div className={
            classnames(
              classes.root,
              classes.itemPointerEvents
            )
          } >
            <MapViewListItem mapView={mapView}
              isTracking={isTracking}
              onEdit={onEdit}
              onDelete={onDelete}
              savedMapViews={savedMapViews}
              onSetMapView={onSetMapView}
              onSetDefaultMapView={onSetDefaultMapView} />
          </div>
        </Fragment>
      ))}
    </List>
  );
};

export default SavedMapViewsChooserList;
